import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import WishFlexBox from "../WishFlexBox";

const WishFileControl = ({
  label,
  initialValue = "",
  initialUrl = "",
  placeholder = "",
  required = false,
  verify = false,
  onVerifyClicked,
  readonly = false,
  onChange,
  onRemove,
  id,
  filter,
  error,
}) => {
  const elementId = id ? id : label ? label?.replace(" ", "") : uuidv4();
  const [elValue, setElValue] = useState(initialValue ?? label);
  const [elUrl, setElUrl] = useState(initialUrl ?? "");

  useEffect(() => {
    setElValue(initialValue ?? label);
    setElUrl(initialUrl ?? "");
  }, [initialUrl, initialValue, label]);

  const additionalAttributes = function () {
    var opts = {};
    if (required) {
      opts["required"] = "required";
    }

    if (readonly) {
      opts["readOnly"] = "readOnly";
    }

    if (filter) {
      opts["accept"] = filter;
    }

    return opts;
  };

  const RenderFilePreview = () => {
    const displayValue = typeof elValue === "string" ? elValue : elValue?.name;
    const hrefValue = elUrl || (typeof elValue === "string" && /^https?:\/\//i.test(elValue) ? elValue : "");

    return (
      <WishFlexBox>
        {hrefValue ? (
          <a href={hrefValue} target="_blank" rel="noreferrer">
            {displayValue}
          </a>
        ) : (
          <span>{displayValue}</span>
        )}
        <button
          className="text-danger"
          onClick={() => {
            setElValue(null);
            setElUrl("");
            onRemove && onRemove();
          }}
        >
          <WishFlexBox>
            <i className="las la-trash-alt"></i>&nbsp;Remove
          </WishFlexBox>
        </button>
      </WishFlexBox>
    );
  };

  const RenderFileInput = () => {
    return (
      <input
        id={elementId}
        name={elementId}
        placeholder={placeholder ?? label}
        type="file"
        className={"form-control" + (error ? " is-invalid" : "")}
        //defaultValue={elValue}
        //value={elValue}
        onChange={(e) => {
          const selectedFile = e.target.files[0];
          setElValue(selectedFile ?? e.target.value);
          setElUrl("");
          onChange && onChange(e.target.value, selectedFile);
        }}
        {...additionalAttributes()}
        //ref={customRef}
      />
    );
  };

  return (
    <div className="form-group row">
      <label htmlFor={elementId} className="col-md-3 col-lg-3 col-sm-12 col-form-label">
        {label}
        {required ? <span className="text-danger"> *</span> : null}
      </label>
      <div className={verify === false ? "col-lg-9 col-md-9 col-sm-12" : "col-5"}>
        {elValue ? <RenderFilePreview /> : <RenderFileInput />}
        {error ? <small className="text-danger d-block mt-1">{error}</small> : null}
      </div>
      {verify === true ? (
        <div className="col-3">
          <button
            className="btn btn-primary btn-block"
            onClick={(e) => {
              onVerifyClicked && onVerifyClicked(e);
            }}
          >
            Verify
          </button>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default WishFileControl;
